(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('pagination', PaginationDirective);

  PaginationDirective.$inject = [
    '$routeParams'
  ];

  function PaginationDirective($routeParams) {
    return {
      restrict: 'E',
      templateUrl: 'views/_pagination.html',
      scope: {
        walk: '&',
        pages: '<'
      },
      link(scope) {
        scope.currentPage = $routeParams.page || 1;

        scope.setPage = function(page) {
          scope.walk({ page });
        };

        scope.$on('$routeUpdate', () => {
          scope.currentPage = $routeParams.page || 1;
        });
      }
    };
  }
}());
